import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Announcement from '@views/Announcement';
import ProfileRankings from '@views/ProfileRankings';

import config from '@config';
import { UserPropsTypes } from '@models/User';
import { RankingPropsTypes } from '@models/Ranking';

import { selectMyRankings } from '@selectors/ranking';

import './MyRankings.css';

export const MyRankings = ({ user, rankings }) => (
  <div className="MyRankings">
    <Announcement />
    <div className="hero-bg">
      <div className="hero-content">
        <h2>Mis torneos</h2>
        <p>Competí con tus amigos, familiares o compañeros de trabajo o estudio y demostrá que sos el que más sabe de fútbol. </p>
      </div>
    </div>
    <div className="MyRankings-container">
      <div className="card">
        {rankings && <ProfileRankings rankings={rankings} />}
      </div>
    </div>
  </div>
);

MyRankings.propTypes = {
  user: PropTypes.shape(UserPropsTypes),
  rankings: PropTypes.arrayOf(PropTypes.shape(RankingPropsTypes)),
};

export const mapStateToProps = (state) => ({
  user: state.user,
  rankings: selectMyRankings(state),
});

export default connect(mapStateToProps)(MyRankings);
